import { computeObjectAABB } from "./auto-box-collider";

export function getXRArtworkInspectDistance(scene, box) {
  const xr = scene.renderer?.xr;
  const eyes = xr?.isPresenting ? xr.getCamera().cameras : [];
  const cameras = eyes.length ? eyes : [scene.camera];
  const size = box.getSize(new THREE.Vector3());
  let distance = 0.25;
  for (const camera of cameras) {
    const projection = camera.projectionMatrix.elements;
    // Use the narrower side of asymmetric eye frusta. No desktop aspect or extra VR multiplier.
    const tanHorizontal = (1 - Math.abs(projection[8])) / projection[0];
    const tanVertical = (1 - Math.abs(projection[9])) / projection[5];
    if (tanHorizontal <= 0 || tanVertical <= 0) continue;
    distance = Math.max(
      distance,
      size.z / 2 + 1.15 * Math.max(size.x / (2 * tanHorizontal), size.y / (2 * tanVertical))
    );
  }
  return distance;
}

// Return bounds in the pivot's orientation, without its scale, plus their world-space center.
export function getXRArtworkInspectFraming(inspectable, pivot) {
  const scene = inspectable.el?.sceneEl;
  if (!scene || !(scene.is("vr-mode") || scene.is("ar-mode"))) return null;
  const infos = Array.from(inspectable.el.querySelectorAll("[artwork-info]"))
    .map(el => el.components["artwork-info"])
    .filter(info => info?.labelContainer?.object3D.visible && info.getInspectBounds);
  const controls = scene.systems?.["hubs-systems"]?.cameraSystem.objectInspectControls;
  const hasObjectControls = controls?.target === inspectable && controls.el.object3D.visible;
  if (!infos.length && !hasObjectControls) return null;

  pivot.updateWorldMatrix(true, true);
  const position = new THREE.Vector3();
  const rotation = new THREE.Quaternion();
  pivot.matrixWorld.decompose(position, rotation, new THREE.Vector3());
  const frame = new THREE.Matrix4().compose(position, rotation, new THREE.Vector3(1, 1, 1));
  const inverseFrame = frame.clone().invert();
  const mesh = inspectable.el.getObject3D("mesh") || inspectable;
  const box = computeObjectAABB(mesh, new THREE.Box3(), true).applyMatrix4(inverseFrame);
  for (const info of infos) {
    box.union(info.getInspectBounds().applyMatrix4(inverseFrame));
  }
  if (hasObjectControls) box.union(controls.getBounds().applyMatrix4(inverseFrame));
  return { box, center: box.getCenter(new THREE.Vector3()).applyMatrix4(frame) };
}
